import { api } from '@/lib/api'

type Props = {
  payrollBulkPaymentId: string
}

export function retryHistoricalPayment({ payrollBulkPaymentId }: Props) {
  return api.post(`/v1/me/contractor-payments/retry`, {
    payrollBulkPaymentId,
  })
}
